import api from '../utils/api';
import config from '../config';

const accountManagementService = {
  /**
   * Unlock a user account
   * @param {number} userId - User ID to unlock
   * @returns {Promise<Object>} Response with success message
   */
  unlockAccount: async (userId) => {
    return api.post(config.endpoints.accountManagement.unlockAccount, { userId });
  },

  /**
   * Get locked user accounts
   * @param {string} keyword - Optional search keyword
   * @returns {Promise<Array>} List of locked accounts
   */
  getLockedAccounts: async (keyword = '') => {
    const query = keyword ? `?keyword=${encodeURIComponent(keyword)}` : '';
    return api.get(`${config.endpoints.accountManagement.lockedAccounts}${query}`);
  },

  /**
   * Check if a user account is locked
   * @param {number} userId - User ID to check
   * @returns {Promise<Object>} Response with locked status
   */
  isAccountLocked: async (userId) => {
    return api.get(`${config.endpoints.accountManagement.isLocked}/${userId}`);
  },
};

export default accountManagementService;
